module.exports = __webpack_public_path__ + "static/img/dkl_favicon.7a48aa1.png";